import { configureStore } from '@reduxjs/toolkit';
import projectReducer from './project/projectSlice';
import uiReducer from './ui/uiSlice';

export const store = configureStore({
  reducer: {
    project: projectReducer,
    ui: uiReducer,
  },
});

export default store;
